import { Stack } from "@mui/material"
import { CSSProperties } from "react"
import { makeStyles } from "tss-react/mui"

import type { ResourceTenantSegment } from "./tenantUsageViewModel"

const useStyles = makeStyles()((theme) => ({
    // The uncovered track shows through as the idle (unbooked) remainder of the bar.
    bar: {
        width: "100%",
        height: ".75rem",
        borderRadius: ".5rem",
        overflow: "hidden",
        backgroundColor: theme.palette.tailwind.slate[200],
    },
    segment: {
        height: "100%",
        width: "var(--seg-width)",
        backgroundColor: "var(--seg-color)",
        transition: "opacity .15s ease",
    },
    segmentDimmed: {
        opacity: 0.3,
    },
}))

type SegmentedBarProps = Readonly<{
    segments: ReadonlyArray<ResourceTenantSegment>
    hoveredKey?: string | null
    onHoverSegment?: (key: string | null) => void
    getSegmentLabel: (segment: ResourceTenantSegment) => string
}>

export function SegmentedBar({ segments, hoveredKey, onHoverSegment, getSegmentLabel }: SegmentedBarProps) {
    const { classes, cx } = useStyles()

    return (
        <Stack direction="row" className={classes.bar}>
            {segments.map((segment) => {
                // CSS custom properties: the DOM CSSProperties type does not cover custom props.
                const style = { "--seg-width": `${segment.usageRate}%`, "--seg-color": segment.color } as CSSProperties
                const dimmed = hoveredKey != null && hoveredKey !== segment.key

                return (
                    <div
                        key={segment.key}
                        className={cx(classes.segment, dimmed && classes.segmentDimmed)}
                        style={style}
                        title={getSegmentLabel(segment)}
                        onMouseEnter={() => onHoverSegment?.(segment.key)}
                        onMouseLeave={() => onHoverSegment?.(null)}
                    />
                )
            })}
        </Stack>
    )
}
